export const initCookiePolicy = () => {
  const sec = document.getElementById("ot-sdk-cookie-policy");
  if (sec && window.OneTrust) {
    //console.log("initCookiePolicy exec");
    try {
      window.OneTrust.initializeCookiePolicyHtml();
    } catch (err) {
      console.error("initCookiePolicy err: ", err);
    }
  }
};
